import Cookies from 'universal-cookie';

const { REACT_APP_COOKIE_DOMAIN } = process.env;

export default {
  COOKIE_NECESSARY: 'feller.c.necessary',
  COOKIE_ANALYTICS: 'feller.c.analytics',
  GOOGLE_ANALYTICS_OPT_OUT: 'google-analytics-opt-out',
};

export const createCookiesJar = () => {
  return new Cookies();
};

export const setCookieTenYearsFromNow = (cookieName, cookieValue, cookieJar) => {
  const tenYearsFromNow = new Date(new Date().getTime() + 10 * 365 * 24 * 60 * 60 * 1000);

  cookieJar.set(cookieName, cookieValue, {
    path: '/',
    expires: tenYearsFromNow,
    secure: true,
    domain: REACT_APP_COOKIE_DOMAIN,
  });
};

export const removeCookie = (cookieName, cookieJar) => {
  cookieJar.remove(cookieName, {
    path: '/',
    secure: true,
    domain: REACT_APP_COOKIE_DOMAIN,
  });
};
